import { Component, Input } from '@angular/core';
import { trackByRef } from 'src/app/lego-utils';
import { ItemStructure } from 'src/app/models/domain';

@Component({
  selector: 'em-item-structure',
  templateUrl: './item-structure.component.html',
  standalone: false,
})
export class ItemStructureComponent {
  @Input() public itemStructure?: ItemStructure;
  @Input() public error = '';
  @Input() public loading = false;

  public readonly trackByRef = trackByRef;
}
